import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { OperacoesService} from  '../services/api/cadastros/OperacoesService';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';

type TAutoCompleteOption = {
  idoperacao: string;
  label: string;
}

interface IAutoCompleteOperacoesProps {
  isExternalLoading?: boolean;
  uuidoperacao?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}

export const AutoCompleteOperacoes01: React.FC<IAutoCompleteOperacoesProps> = ({ isExternalLoading = false, uuidoperacao, nome }) => {
  
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>('');

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  

  useEffect(() => {
    setIsLoading(true);
    debounce(() => {  
      OperacoesService.getAllList(selectedId)
        .then((result) => {
          setIsLoading(false); 
          if (result instanceof Error) {
          } else {
            setOpcoes(result.data.map(operacoes => ({ idoperacao: operacoes.idoperacao, label: operacoes.descricao })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idoperacao === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idoperacao); uuidoperacao?.(newValue?.idoperacao); nome?.(newValue?.label); setBusca(''); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Operações"
          
        />
      )}
    />
  );
};